import AssigneesToolbar from '../../assignees/AssigneesToolbar';
import {useI18Next} from '../../../../../../common/helpers/react/hooks/useI18Next';
import {ButtonConfig} from '../../../../../../controllers/dialog/ButtonConfig';
import {useMemo} from 'react';
import {useControllers} from '../../../../../../common/helpers/react/hooks/useControllers';
import {tAsString} from '../../../../../../common/helpers/react/text/tAsString';
import {ButtonSize} from '@sabre/spark-react-core/types';

export default function AgentsToolbar() {
    const {lang} = useI18Next();
    const controllers = useControllers();
    const http = controllers.http;
    const hasAgentList = controllers.groups.getAssigneesSearchResults$().useState()?.hasAgentList ?? false;

    const toolbarButtons: ButtonConfig[] = useMemo(() => [
        ...(hasAgentList ? [{
            id: 'qa-add-lock-button',
            onClick: () => http.navigateTo('agents/lock'),
            children: tAsString('MANAGE_LOCK'),
            textOnly: true,
            size: ButtonSize.SMALL
        }] : []),
        {
            id: 'qa-add-assignee-button',
            onClick: () => http.navigateTo('agents/add'),
            children: tAsString('ADD_TO_GROUP'),
            textOnly: true,
            size: ButtonSize.SMALL
        }
    ], [lang, hasAgentList]);

    return <AssigneesToolbar buttonsConfig={toolbarButtons}/>;
}